import { useState } from 'react';
import FitLiveGateModal from './FitLiveGateModal';

/**
 * Detalle de clase (estilo Peloton adaptado a crema Fit Live).
 */
export default function FitLiveClassDetail({
  classItem,
  trainer,
  schedule = [],
  onBack,
  onTryFree,
  onLogin,
}) {
  const [tab, setTab] = useState('cronograma');

  if (!classItem) return null;

  const dayOrder = [1, 2, 3, 4, 5, 6, 0];
  const dayNames = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
  const isReplay = classItem.tipo === 'replay' || classItem.isReplay;

  return (
    <div className="fl-detail" data-testid="fit-live-class-detail">
      <button type="button" className="fl-detail-back" onClick={onBack}>
        ← Volver
      </button>

      <section
        className="fl-detail-hero"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(28,25,23,.88) 0%, rgba(28,25,23,.45) 48%, rgba(28,25,23,.2) 100%), url(${classItem.image})`,
        }}
      >
        <div className="fl-detail-hero-copy">
          <p className="fl-detail-level">{classItem.level || 'Todos'}</p>
          <h1>{classItem.title}</h1>
          <p className="fl-detail-aired">{classItem.aired || `${classItem.duration || 40} min`}</p>
          <div className="fl-detail-chips">
            <span>{classItem.coach || trainer?.label}</span>
            <span>{classItem.discipline || trainer?.specialty || 'Fit Live'}</span>
            {isReplay ? <span>{classItem.freeReplay ? 'Grabada · gratis' : 'Clase grabada'}</span> : null}
          </div>
        </div>
      </section>

      <div className="fl-detail-bar">
        <div className="fl-detail-bar-tabs" role="tablist">
          <button
            type="button"
            className={tab === 'cronograma' ? 'is-active' : ''}
            role="tab"
            aria-selected={tab === 'cronograma'}
            onClick={() => setTab('cronograma')}
          >
            Cronograma
          </button>
          <button
            type="button"
            className={tab === 'info' ? 'is-active' : ''}
            role="tab"
            aria-selected={tab === 'info'}
            onClick={() => setTab('info')}
          >
            Info
          </button>
        </div>
        <div className="fl-detail-bar-cta">
          <button type="button" className="fl-pub-link fl-detail-member" onClick={onLogin}>
            ¿Ya eres miembro? Acceso
          </button>
          <button type="button" className="fl-detail-try" onClick={onTryFree}>
            {isReplay ? 'Ver clase grabada' : 'Reservar clase'}
          </button>
        </div>
      </div>

      <div className="fl-detail-body">
        {tab === 'info' ? (
          <>
            <h2>Información de la clase</h2>
            <p>{classItem.blurb || trainer?.bio || 'Clase Fit Live en vivo o grabada.'}</p>
            <p className="fl-detail-meta-line">
              {classItem.duration || 40}
              {' '}
              min ·
              {' '}
              {classItem.freeReplay || Number(classItem.tokens) === 0
                ? 'Gratis'
                : `${classItem.tokens || 0} tokens`}
            </p>
            <dl className="fl-detail-info-list">
              <div>
                <dt>Entrenador</dt>
                <dd>{classItem.coach || trainer?.label || '—'}</dd>
              </div>
              <div>
                <dt>Disciplina</dt>
                <dd>{classItem.discipline || trainer?.specialty || '—'}</dd>
              </div>
              <div>
                <dt>Nivel</dt>
                <dd>{classItem.level || '—'}</dd>
              </div>
              <div>
                <dt>Tipo</dt>
                <dd>{isReplay ? 'Clase grabada (replay)' : 'En vivo'}</dd>
              </div>
              {classItem.when ? (
                <div>
                  <dt>Horario</dt>
                  <dd>{classItem.when}</dd>
                </div>
              ) : null}
              {trainer?.bio ? (
                <div>
                  <dt>Sobre el entrenador</dt>
                  <dd>{trainer.bio}</dd>
                </div>
              ) : null}
            </dl>
          </>
        ) : (
          <>
            <h2>Más información</h2>
            <p>{classItem.blurb || trainer?.bio || 'Clase Fit Live en vivo o grabada.'}</p>
            <p className="fl-detail-meta-line">
              {classItem.duration || 40}
              {' '}
              min ·
              {' '}
              {classItem.freeReplay || Number(classItem.tokens) === 0
                ? 'Gratis'
                : `${classItem.tokens || 0} tokens`}
            </p>

            <h3>Horarios del entrenador</h3>
            <div className="fl-detail-schedule">
              {dayOrder.map((d) => {
                const slots = (schedule || []).filter((s) => s.day === d);
                if (!slots.length) return null;
                return (
                  <div key={d} className="fl-detail-day">
                    <strong>{dayNames[d]}</strong>
                    <ul>
                      {slots.map((s) => (
                        <li key={`${d}-${s.time}-${s.title}`}>
                          <em>{s.time}</em>
                          {' '}
                          {s.title}
                          <span>
                            {s.duration}
                            {' '}
                            min ·
                            {s.tokens}
                            {' '}
                            tok
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
              {!schedule?.length ? (
                <p className="fl-note">
                  {isReplay
                    ? 'Esta es una clase grabada: no tiene horario en vivo. Usa el botón para verla.'
                    : 'Sin horarios publicados todavía.'}
                </p>
              ) : null}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// re-export tip for tree (modal used by parent)
export { FitLiveGateModal };
